"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function selectProgress(state, action) {
    if (state == undefined || state.progress == undefined) {
        return { inProgress: false, error: undefined };
    }
    return state.progress[action];
}
exports.selectProgress = selectProgress;
function didProgressComplete(progressNow, progressBefore) {
    if (progressNow == undefined || progressBefore == undefined) {
        return false;
    }
    if (progressNow.inProgress === false && progressBefore.inProgress === true && progressNow.error == undefined) {
        return true;
    }
    return false;
}
exports.didProgressComplete = didProgressComplete;
function didProgressFail(progressNow, progressBefore) {
    if (progressNow == undefined || progressBefore == undefined) {
        return false;
    }
    if (progressNow.inProgress === false && progressBefore.inProgress === true && progressNow.error != undefined) {
        return true;
    }
    return false;
}
exports.didProgressFail = didProgressFail;
